export default __webpack_public_path__ + "static/mobile-menu-logo-5d547f107c1a38681edd7e673560032c.png";